import{useCallback as l}from"react";import{useLatest as n}from"../useLatest/index.js";function o(e){const r=n(e);return l(a=>{var t;return(t=r.current)==null?void 0:t.call(r,a)},[])}export{o as useLatestCallback};
//# sourceMappingURL=index.js.map
